import AuthenticationResponse from "../api/responses/AuthenticationResponse";

type JwtPayload = Record<string, unknown>;
const userIdClaimName = "nameid";

function decodeBase64Url(value: string): string {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const paddedBase64 = base64.padEnd(base64.length + ((4 - base64.length % 4) % 4), "=");

  return atob(paddedBase64);
}

function decodeJwtPayload(token: string | undefined): JwtPayload | null {
  if (!token) {
    return null;
  }

  const [, payload] = token.split(".");

  if (!payload) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(payload)) as JwtPayload;
  } catch {
    return null;
  }
}

function getUserIdFromToken(token: string | undefined): string | null {
  const payload = decodeJwtPayload(token);

  if (!payload) {
    return null;
  }

  const claimEntry = Object.entries(payload).find(
    ([key]) => key.toLowerCase() === userIdClaimName
  );
  const claimValue = claimEntry?.[1];

  if (typeof claimValue === "string" && claimValue.trim()) {
    return claimValue;
  }

  return null;
}

export function getLoggedInUserId(
  authenticationResponse: AuthenticationResponse | undefined
): string | null {
  if (authenticationResponse?.id) {
    return authenticationResponse.id;
  }

  return getUserIdFromToken(authenticationResponse?.token);
}
